import React from "react";
import Footer from "./containers/Footer"
import Header from "./containers/Header";

interface children {
    child: JSX.Element | React.ReactNode
  }
function InsidePanelsLayout({children}:any) {
 //console.log(children)
    return (
      <>
        <Header />
        <div className="min-height-75vh">
          {children}
        </div>
         
        <Footer />
      </>
    );
  }
    
    export default InsidePanelsLayout;
    